import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18N } from '../../legacy/lib/use-i18n';
import AskLink from '../../ui/action-plug/ask-link.vue';
import BasePromoBadge from '../../ui/base-promo-badge/base-promo-badge.vue';

type Props = {
  title: string;
  description: string;
  mailSubject: string;
  mailBody: string;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'action-plug',
  props: {
    title: {},
    description: {},
    mailSubject: {},
    mailBody: {}
  },
  setup(__props: any) {


const i18n = useI18N();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.plug)
  }, [
    _createVNode(BasePromoBadge, {
      text: _unref(i18n)('not-set'),
      icon: "lock-main",
      type: "alt"
    }, null, 8, ["text"]),
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.title)
    }, _toDisplayString(__props.title), 3),
    _renderSlot(_ctx.$slots, "description", {}, () => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.description)
      }, _toDisplayString(__props.description), 3)
    ]),
    _createVNode(AskLink, {
      "mail-subject": __props.mailSubject,
      "mail-body": __props.mailBody,
      color: "green"
    }, null, 8, ["mail-subject", "mail-body"])
  ], 2))
}
}

})